import { useQuery } from '@tanstack/react-query';
import type { CustomerRevenueResponse } from '@metron/shared';
import { useApiClient } from './useApiClient.ts';

/**
 * Per-customer Epicor revenue (GET /customers/revenue). Pass
 * `hasPermission(Permission.VIEW_REVENUE)` as `enabled` so non-admins never
 * call the endpoint. One cached response serves the list and detail pages.
 */
export function useCustomerRevenue(enabled: boolean) {
  const apiClient = useApiClient();
  return useQuery({
    queryKey: ['customer-revenue'],
    queryFn: () => apiClient.get<CustomerRevenueResponse>('customers/revenue'),
    enabled,
  });
}
